export default "__VITE_ASSET__Chr2BHyd__"